import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/semantic.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';

// Suppress findDOMNode warnings from third-party libraries
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    args[0] && 
    typeof args[0] === 'string' && 
    (
      args[0].includes('findDOMNode') || 
      args[0].includes('RefFindNode') ||
      args[0].includes('StrictMode') ||
      args[0].includes('createPortal') ||
      args[0].includes('Maximum update depth exceeded') // Suppress maximum update depth warnings
    )
  ) {
    // Suppress React warnings related to legacy component APIs and update depth issues
    return;
  }
  originalConsoleError(...args);
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
